'use strict'
var twentyninetimes = twentyninetimes || {}

const expandLists = document.querySelectorAll('.js-block-expand-list')

twentyninetimes.expandList =
  twentyninetimes.expandList ||
  (function () {
    function init() {
      if (expandLists && expandLists.length > 0) {
        for (let i = 0; i < expandLists.length; i++) {
          setupExpandList(expandLists[i])
        }
      }
    }

    function setupExpandList(expandList) {
      if (expandList) {
        const expandItems = expandList.querySelectorAll(
          '.js-block-expand-list-item'
        )
        const expandListShowAllTrigger = expandList.parentNode.querySelector(
          '.js-block-expand-list-show-all'
        )

        let threeItemsHeight = 0

        if (!expandListShowAllTrigger || !expandItems) return null

        for (let i = 0; i < expandItems.length; i++) {
          const currentItem = expandItems[i]
          const currentItemHeight = currentItem.getBoundingClientRect().height
          const item = currentItem.getAttribute('data-item')

          if (item <= 2) {
            threeItemsHeight = threeItemsHeight + currentItemHeight
          }
        }

        expandList.style.maxHeight = threeItemsHeight + 'px'

        expandListShowAllTrigger.addEventListener('click', function () {
          if (expandList.classList.contains('open')) {
            expandList.classList.remove('open')
            expandListShowAllTrigger.classList.remove('open')
            expandList.style.maxHeight = threeItemsHeight + 'px'
          } else {
            expandList.classList.add('open')
            expandListShowAllTrigger.classList.add('open')
            expandList.style.maxHeight = expandList.scrollHeight + 'px'
          }
        })
      }
    }

    return {
      init: init,
    }
  })()
